import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ProductsTypesActions } from 'store/ducks/productsTypes';

import { Access } from 'common';
import { Page, Panel, Loading, Pagination, Breadcrumbs } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Pontos', to: '/points' }, { name: 'Tipo de Produtos', to: '' }],
  };

  componentDidMount() {
    const { location, getProductsTypesRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getProductsTypesRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getProductsTypesRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getProductsTypesRequest(queryString.parse(location.search).page);
    }
  }

  render() {
    const { breadcrumbs } = this.state;
    const { productsTypes } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Tipos de Produtos</Page.Title>

        <Panel className="panel-list">
          {!productsTypes.data.length && productsTypes.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {productsTypes.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>código</th>
                    <th className="big-size-80">descrição</th>
                    <th>situação</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!productsTypes.data.length && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {productsTypes.data.map((productsTypes, index) => (
                    <tr key={productsTypes.id}>
                      <td>{index + 1}</td>
                      <td>{productsTypes.attributes.name}</td>
                      <td className={productsTypes.attributes.score ? 'label-active' : 'label-inactive'}>
                        {productsTypes.attributes.score ? 'Sim' : 'Não'}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-product-types') && (
                          <Link to={`/points/products-types/${productsTypes.id}/edit`} className="button-icon">
                            <span className="glyph glyph-pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="4" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={productsTypes.page}
                total={productsTypes.totals}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  productsTypes: state.productsTypes,
});

const mapActions = dispatch => bindActionCreators(ProductsTypesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
